import $foreign from "./foreign.cjs";
var arrayExtend = $foreign.arrayExtend;
export { arrayExtend };
